import { Component, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IonModal, LoadingController, ToastController} from '@ionic/angular';
import {DefaultComponent} from "../../shared/components/default.component";
import {AuthenticationService} from "../../shared/_services/authentication.service";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {takeUntil} from "rxjs/operators";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage extends DefaultComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  isLoading = false;
  authForm: FormGroup;


    constructor(
      private fb: FormBuilder,
      private loadingCtrl: LoadingController,
      private authenticationService: AuthenticationService,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
        toastController: ToastController
  ) {
      super(router, activatedRoute, sharedRoutesService, toastController);
  }

  ngOnInit() {
      this.authForm = this.fb.group({
          email: ['', [Validators.required, Validators.email]],
          password: ['', [Validators.required, Validators.minLength(6)]]
      });
  }


    onLoginClick() {
        console.log(this.authForm.value);
        if (this.authForm.invalid) {
            return;
        }
        this.isLoading = true;
        this.loadingCtrl.create({ keyboardClose: true, message: 'Logging in..' }).then(loadingEl => {
            loadingEl.present();

            const queryParams = this.authForm.value;
            this.authenticationService.login(queryParams).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
                data => {
                    this.isLoading = false;
                    loadingEl.dismiss();
                    this.router.navigate(['private/main/dashboard']);
                    console.log(data);
                },
                error => {
                    this.isLoading = false;
                    loadingEl.dismiss();


                    // handle error (e.g., show error message)
                }
            );
        });
    }

    gotoRegister() {
        this.router.navigate(['authentication/signup']);
    }
    gotoForgot() {
        this.router.navigate(['authentication/forgot']);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(undefined);
        this.ngUnsubscribe.complete();
    }


}
